<!--
 * @创建文件时间: 2020-03-30 17:31:40
 * @最后修改人: lfq
 * @最后修改时间: 2020-07-13 10:23:27
 * @联系Qq:1360484677
 * @文件介绍: 评定报表
 -->
<template>
    <el-row style="margin-bottom: 20px">
      <el-col :span="22">
        <ve-line :data="chartData" :after-set-option="setOptions"></ve-line>
      </el-col>
      <el-col :span="2">
        <ul class="democolor" style="list-style-type:none">
            <li><span style="background-color: #5B9BD5;"></span>优</li>
            <li><span style="background-color: #A5E690;"></span>良</li>
            <li><span style="background-color: #cca4e3;"></span>中</li>
            <li><span style="background-color: #fff143;"></span>次</li>
            <li><span style="background-color: #f2a0a1;"></span>差</li>
        </ul>
      </el-col>
    </el-row>
</template>
<style>
.democolor {
    width: 120px;;
    right: 5px;
    top: 210px;
    z-index: 1000;
    width: 55px !important;
}
.democolor li {
    position: relative;
    width: 100px !important;
    position: relative;
    padding: 3px 20px !important;
    font-size: 14px !important;
    height: 24px !important;
    line-height: 24px !important;
}
.democolor li span{
  display: inline-block;
  height: 15px;
  width: 15px;
  background-color: #0094ff;
  margin-right: 12px;
  position: absolute;
  top: 7px;
  left: 0;
}
</style>
<script>
import VeLine from 'v-charts/lib/line'
import 'v-charts/lib/style.css'
export default {
  name: 'assessCharts',
  components: {VeLine},
  props: {
    assessData: {
      type: Object,
      default: () => {}
    },
  },
  data () {
    return {
        chartData: {testBatchId:0}
    }
  },
  computed: {},
  created () {
  },
  watch: {
      "assessData":function(params) {
          if(params.data.length==0){
              this.chartData.testBatchId=0;
          }else{
            if(this.chartData.testBatchId==params.data[0].testBatchId){
            }else{this.chartData.testBatchId=params.data[0].testBatchId;}
          }
      }
  },
  mounted () {},
  methods: {
    setOptions(chartObj){
      var map = {};
      var rows = [];
      rows=this.assessData.data;
      var barStytle = {
            normal: {
                barBorderRadius: 0,
                borderWidth: 10,
                color: function (model) {
                    var startStake = model['data']['name'];
                    var seriesName = model['seriesName'];
                    var value = map[seriesName + "-" + startStake];
                    var level = parseInt(value / 20);
                    switch (level) {
                        case 5: return '#5B9BD5';
                        case 4: return '#5B9BD5';
                        case 3: return '#A5E690';
                        case 2: return '#cca4e3';
                        case 1: return '#fff143';
                        case 0: return '#f2a0a1';
                        default: return '#5B9BD5';
                    }
                }
            }
        }
      var series = [
          { name: "_MQI", type: "bar", stack: "总量", "barGap": 10, barCategoryGap: 0, data: [], itemStyle: barStytle },
          { name: "_PQI", type: "bar", stack: "总量", data: [], itemStyle: barStytle },
          { name: "_PCI", type: "bar", stack: "总量", data: [], itemStyle: barStytle },
          { name: "_RDI", type: "bar", stack: "总量", data: [], itemStyle: barStytle },
          { name: "_RQI", type: "bar", stack: "总量", data: [], itemStyle: barStytle },
          { name: "_PSSI", type: "bar", stack: "总量", data: [], itemStyle: barStytle },
          { name: "_SRI", type: "bar", stack: "总量", data: [], itemStyle: barStytle },
          { name: "_SCI", type: "bar", stack: "总量", data: [], itemStyle: barStytle },
          { name: "_BCI", type: "bar", stack: "总量", data: [], itemStyle: barStytle },
          { name: "_TCI", type: "bar", stack: "总量", data: [], itemStyle: barStytle },

          { name: "MQI", type: "line", symbolSize: 4, symbol: "circle", data: [] },
          { name: "PQI", type: "line", symbolSize: 4, symbol: "circle", data: [] },
          { name: "PCI", type: "line", symbolSize: 4, symbol: "circle", data: [] },
          { name: "RDI", type: "line", symbolSize: 4, symbol: "circle", data: [] },
          { name: "RQI", type: "line", symbolSize: 4, symbol: "circle", data: [] },
          { name: "PSSI", type: "line", symbolSize: 4, symbol: "circle", data: [] },
          { name: "SRI", type: "line", symbolSize: 4, symbol: "circle", data: [] },
          { name: "SCI", type: "line", symbolSize: 4, symbol: "circle", data: [] },
          { name: "BCI", type: "line", symbolSize: 4, symbol: "circle", data: [] },
          { name: "TCI", type: "line", symbolSize: 4, symbol: "circle", data: [] }
      ];
      rows.sort(function (x, y) {
          return x['startStake'] - y['startStake'];
      })
      var xAxisData = [];
      var stateData = [];
      for (var m = 0; m < rows.length; m++) {
          stateData.push({
              value:10,
              name:rows[m]['cellDivisionCode']+''
          });
      }
      for (var i = 0; i < rows.length; i++) {
          var currRow = rows[i];
          xAxisData.push(currRow['startStake']);
          for (var k = 0; k < series.length; k++) {
              var seriesItem = series[k];
              var name = seriesItem['name'];
              var field = name.toLowerCase();///显示MQI，获取值mqiRatio,toLowerCase()字符串转换小写 + 'Ratio'
              if (name.indexOf('_') > -1) {
                  seriesItem['data'] = stateData;
                  map[name + "-" + currRow['cellDivisionCode']] = currRow[field.substring(1)];
                  continue;
              }
              seriesItem.data.push({ value: currRow[field] + 110, theRow: currRow });
          }
      }
      var option = {
            tooltip: {
                trigger: "axis", axisPointer: { type: "shadow" },
                formatter: function (params) {
                    var text = '划分编号：' + params[0]['name'] + '</br>';
                    for (var n = 0; n < params.length; n++) {
                        var currItem = params[n];
                        if (currItem['seriesName'].indexOf('_') > -1) { continue; }
                        var theRow = currItem['data']['theRow'];
                        var driv = theRow['drivingDirection'];
                        text += driv  + "-" + currItem['seriesName'] + '：' + (currItem['data']['value'] ? (currItem['data']['value'] - 110).toFixed(3) : '') + '</br>';
                    }
                    return text;
                }
            },
            grid: { borderWidth: 0, top: 30, bottom: 60, left: 130 },
            legend: { orient: 'horizontal', data: ['MQI', 'PQI', 'PCI', 'RDI', 'RQI', 'PSSI', 'SRI', 'SCI', 'DCI', 'BCI', 'TCI'] },
            calculable: true,
            xAxis: [{
                type: "category",
                data: xAxisData, axisLabel: {
                    interval: 0,
                    rotate: 400,
                    show: true,
                    splitNumber: 15,
                    textStyle: {
                        fontFamily: "微软雅黑",
                        fontSize: 12
                    },
                    formatter: function (value, index) {
                      if (value == undefined||value == "0") {
                            return "K0+000"
                        } else {
                            let reg = new RegExp("^K.*?");
                            value = (value * 1.000).toFixed(3)
                            if (reg.test(value)) {
                                value = value.slice(1, -4) + value.slice(-3)
                            } else {
                                let arry = value.split('.')
                                value = 'K' + arry[0] + '+' + arry[1]
                            }
                            return value;
                        }
                        
                    }
                },
            }],
            yAxis: [{
                type: "value", interval: 10, min: 0, max: 210, axisLabel: {// interval: 10, min: 0, max: 210,增加行数
                    formatter: function (value) {
                        switch (value) {
                            case 0: return 'MQI';
                            case 10: return 'PQI';
                            case 20: return 'PCI';
                            case 30: return 'RDI';
                            case 40: return 'RQI';
                            case 50: return 'PSSI';
                            case 60: return 'SRI';
                            case 70: return 'SCI';
                            case 80: return 'BCI';
                            case 90: return 'TCI';
                            case 100: return '';
                            default: return value - 110;
                        }
                    }
                }
            }],
            dataZoom: [
                {
                    show: true, height: 30, xAxisIndex: [0], bottom: 30, startValue: 0,
                    endValue: 40, handleSize: "100%", borderColor: "#90979c"
                },
                { type: "inside", show: true, height: 15, start: 1, end: 35 }
            ],
            series: series
        };
      chartObj.setOption(option);
    },
  }
}
</script>

<style scoped>

</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/components/EchartTools/assessCharts.vue"
}
</vue-filename-injector>
